$(->
  if(!Modernizr.input.placeholder)
    active = $(':focus')
    $('input:not(:submit)').focus(->
      if $(this).attr('placeholder')
        if $(this).val() == $(this).attr('placeholder')
          $(this).val('').removeClass('hasPlaceholder')
    ).blur(->
      if $(this).attr('placeholder')
        if $(this).val() == '' || $(this).val() == $(this).attr('placeholder')
          $(this).val($(this).attr('placeholder')).addClass('hasPlaceholder')
    )
    $('input:not(:submit)').blur()
    $(active).focus()
    $('form').submit(->
      $(this).find('.hasPlaceholder').val('')
      true
    )
)
